import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Subject } from 'rxjs';
import { MessageDialogService } from './message-dialog.service';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
})
export class MessageDialogComponent implements OnInit, OnChanges {
  @Input() MessageDialogTitle: string = '';
  @Input() MessageDialogMessage: string = '';
  @Input() ShowCancel: boolean = true;
  @Output() MessageDialogOutput = new EventEmitter<boolean>();

  constructor(
    public messageDialogService: MessageDialogService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {}

  ngOnInit(): void {}
}
